'use client'

import { Hero as HeroUI } from '@chaseweb/ui-library/src'
import { cn } from '@chaseweb/utils/cn'
import { useSplitStore } from '@chaseweb/utils/split'
import { useEffect, useState } from 'react'

import { DownloadLink } from '@/components'
import { useCTAStore } from '@/lib/stores'

export const MobileStickyCta = () => {
  const client = useSplitStore((state) => state.clients.user)
  const stickyCtaTreatment = client?.getTreatment('mobile_sticky_cta')

  const [isVisible, setIsVisible] = useState(false)
  const { heroCtaRef, promoCtaRef } = useCTAStore()

  useEffect(() => {
    if (!client) return

    let heroVisible = true
    let promoVisible = false
    let promoCrossed = false
    let lastScrollY = window.scrollY

    const updateVisibility = () => {
      setIsVisible(!heroVisible && !promoVisible && !promoCrossed)
    }

    const handleIntersection: IntersectionObserverCallback = (entries) => {
      entries.forEach((entry) => {
        const currentScrollY = window.scrollY
        const scrollingDown = currentScrollY > lastScrollY
        const scrollingUp = currentScrollY < lastScrollY

        if (entry.target === heroCtaRef?.current) {
          heroVisible = entry.isIntersecting
        }
        if (entry.target === promoCtaRef?.current) {
          promoVisible = entry.isIntersecting
          if (entry.isIntersecting) {
            promoCrossed = scrollingDown
          } else if (scrollingUp) {
            promoCrossed = false
          }
        }

        lastScrollY = currentScrollY
      })

      updateVisibility()
    }

    const observerOptions = {
      rootMargin: '10px',
      threshold: [0, 0.5, 1],
      root: null,
    }

    const observer = new IntersectionObserver(
      handleIntersection,
      observerOptions,
    )

    if (heroCtaRef?.current) {
      observer.observe(heroCtaRef.current)
    }
    if (promoCtaRef?.current) {
      observer.observe(promoCtaRef.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [heroCtaRef, promoCtaRef, client])

  return (
    stickyCtaTreatment === 'on' && (
      <div
        aria-hidden
        data-testid="MobileStickyCta"
        className={cn(
          'tw-fixed tw-bottom-0 tw-left-0 tw-z-50 tw-w-full tw-bg-white tw-p-4 tw-opacity-0 tw-shadow-sticky-button tw-duration-300 tw-ease-in-out md:tw-hidden',
          {
            'tw-opacity-100': isVisible,
          },
        )}
      >
        <HeroUI.Cta
          variant="primary"
          asChild
          noExternalIcon
          className="tw-mt-0 tw-w-full"
        >
          <DownloadLink sectionLabel="hero">Get the app</DownloadLink>
        </HeroUI.Cta>
      </div>
    )
  )
}
